import React from 'react';
import {IconButton, Popover, Box} from '@mui/material';
import {SVGS} from '../../../assets/images';
import styles from './mobile-info-popup.module.scss';

export interface MobileInfoPopupProps {
    children: React.ReactNode;
    icon?: React.ReactNode;
    iconButtonClassName?: string;
    onOpen?: () => void;
    onClose?: () => void;
}

const MobileInfoPopup: React.FC<MobileInfoPopupProps> = ({ children, icon, iconButtonClassName, onOpen, onClose }) => {
    const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
    const open = Boolean(anchorEl);

    const handleToggle = (event: React.MouseEvent<HTMLButtonElement>) => {
        if (open) {
            setAnchorEl(null);
            onClose?.();
            return;
        }

        setAnchorEl(event.currentTarget);
        onOpen?.();
    };

    const handleClose = () => {
        setAnchorEl(null);
        onClose?.();
    };

    return (
        <>
            <IconButton
                className={iconButtonClassName ? `${styles.iconButton} ${iconButtonClassName}` : styles.iconButton}
                onClick={handleToggle}
            >
                {icon ?? <SVGS.HelpOutlineRoundedIcon />}
            </IconButton>
            <Popover
                open={open}
                onClose={handleClose}
                anchorEl={anchorEl}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                disableScrollLock
                className={styles.popoverPaper}
                slotProps={{
                    paper: {
                        className: styles.popoverPaper,
                        sx: {
                            mt: '5px'
                        }
                    }
                }}
            >
                <Box className={styles.popoverContent}>
                    {children}
                </Box>
            </Popover>
        </>
    );
};

export default React.memo(MobileInfoPopup);
